import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

import Veera from '../media/veera.jpeg';
import Tubunny from '../media/tubunny.JPG';
import Tubby from '../media/tubby.JPG';
import Guruem from '../media/guruem.jpeg';
import Troopie from '../media/troopie.jpeg';
import Nellie from '../media/nellie.jpeg';
import Tubnor from '../media/tubnor.JPG';
import Paldo from '../media/paldo.jpeg';
import Aspen from '../media/aspen.jpeg';
import Hatdog from '../media/hatdog.jpeg';

import car1 from '../media/Home/Carousel/carousel1.JPG'
import car2 from '../media/Home/Carousel/carousel2.jpg'
import car3 from '../media/Home/Carousel/carousel3.jpg'
import car4 from '../media/Home/Carousel/carousel4.jpg'
import car5 from '../media/Home/Carousel/carousel5.jpg'
import car6 from '../media/Home/Carousel/carousel6.jpg'
import car7 from '../media/Home/Carousel/carousel7.jpg'
import car8 from '../media/Home/Carousel/carousel8.jpg'



const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    label: 'car1',
    imgPath: car1
  },
  {
    label: 'car2',
    imgPath: car2
  },
  {
    label: 'car3',
    imgPath: car3
  },
  {
    label: 'car4',
    imgPath: car4
  },
  {
    label: 'car5',
    imgPath: car5
  },
  {
    label: 'car6',
    imgPath: car6
  },
  {
    label: 'car7',
    imgPath: car7
  },
  {
    label: 'car8',
    imgPath: car8
  },
];

function Carousel() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ maxWidth: 417, flexGrow: 1 }}>
      {/* <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 50,
          pl: 2,
          bgcolor: 'background.default',
        }}
      >
        <Typography>{images[activeStep].label}</Typography>
      </Paper> */}
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box
                component="img"
                sx={{
                  height: 290,
                  display: 'block',
                  maxWidth: 500,
                  overflow: 'hidden',
                  width: '100%',
                }}
                src={step.imgPath}
                alt={step.label}
              />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      {/* <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      /> */}
    </Box>
  );
}

export default Carousel;